import * as React from "react"
import * as styles from "./styles.module.scss"
import Footer from "components/Footer"
import HeroCircle from "components/HeroCircle"
import Document from "components/Document"
import Media from "components/Media"
import MissionQuote from "components/MissionQuote"
import MissionWhat from "components/MissionWhat"
import Navbar from "components/Navbar"
import { GetStartedType } from "components/Navbar/GetStartedButton"
import OurMission from "components/OurMission"
import SideNav from "components/SideNav"
import { brand } from "config/brand"
import PageWrapper, { PaddingTop } from "components/PageWrapper"
import SubNavbarAbout from "components/SubNavbarAbout"
import imgVishalMission from "images/vishal-mission.jpg"

const ldJson = `
{
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "${brand.name}",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.6",
    "reviewCount": "57"
  }
}
`

const AboutUs: React.FC = () => {
  return (
    <Document
      description={`The mortgage industry operates as if the internet does not exist. At ${brand.shortName}, we're rebuilding the mortgage process from the ground up.`}
      pageClass="AboutUsPage"
      pageId="AboutUsPage"
      title="Our mission"
    >
      <Navbar getStartedType={GetStartedType.ALWAYS} />
      <SubNavbarAbout />
      <SideNav />
      <PageWrapper paddingTop={PaddingTop.SubNavbar}>
        <main className={styles.mission}>
          <OurMission />
          <HeroCircle
            heading="The status quo is broken."
            headingSize="md"
            subhead="You can’t trust the mortgage process. It is opaque and stressful. Fees are not transparent and some of them are simply outrageous in size. Commission structures incentivize sales, not support. The system is setup to benefit the insiders — not you."
            subheadSize="md"
            buttonCta="Read his story"
            buttonLink="/content/the-house-that-got-away-why-i-started-better-mortgage/"
            poster={imgVishalMission}
            posterVideoSrc="https://player.vimeo.com/external/296725212.hd.mp4?s=2f7f8bfe104c4aa48f42fee2dae1e22517135ccd&profile_id=174"
            directSourceUrl="https://player.vimeo.com/video/215031211?autoplay=1"
          />
          <MissionWhat />
          <MissionQuote />
        </main>
        <Media />
        <Footer />
      </PageWrapper>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: ldJson }}
      />
    </Document>
  )
}

export default AboutUs
